export default function LicenseBadge({ state }) {
  const map = {
    active: { t: "ACTIVA", c: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
    expired: { t: "EXPIRADA", c: "bg-crimson/15 text-crimson border-crimson/30" },
    never: { t: "SIN PLAN", c: "bg-white/5 text-muted-foreground border-white/10" },
  };
  const s = map[state] || map.never;
  return (
    <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase border ${s.c}`} data-testid="license-badge">
      {s.t}
    </span>
  );
}
